import { TransactionsReportTranslations } from "./transactions-report-pt-br";

export const TRANSACTIONS_REPORT_FR_FR: TransactionsReportTranslations = {
	title: "Liste des transactions",
	descriptionPlace: "Liste de toutes les transactions de la période",
	descriptionEvent: "Liste de toutes les transactions d'événement",
	filter: {
		title: "Filtre",
		emptyFilter: "Cliquez pour filtrer",
		modal: {
			inputPlaceholder: "Tapez ici",
			selectPlaceholder: "Sélectionner ici",
			descriptionEnd: "pour filtrer les transactions",
		},
		modalOptions: {
			terminal: {
				label: "Terminal",
				title: "Numéro de terminal",
				description: "Entrer le numéro du terminal",
			},
			clientDocument: {
				label: "Document client",
				title: "CPF ou numéro de document",
				description: "Saisir le CPF ou le numéro de document du client",
			},
			employee: {
				label: "Employé",
				title: "Nom de l'employé",
				description: "Entrez le nom de l'employé",
			},
			zigCode: {
				label: "Code Zig",
				description: "Entrez le numéro Code Zig",
			},
			paymentMethod: {
				label: "Mode de paiement",
				description: "Sélectionnez un mode de paiement",
			},
			transactionType: {
				label: "Type de transaction",
				description: "Sélectionnez un type de transaction",
			},
			bar: {
				label: "Filtrer par barre",
				title: "Barre",
				description: "Sélectionner une barre",
			},
		},
	},
	print: "Imprimer le rapport",
	table: {
		id: "ID",
		date: "Date",
		syncDate: "Date de synchronisation",
		type: "Type",
		employee: "Employé",
		terminal: "Terminal série",
		deviceId: "ID de l'appareil",
		zigCode: "ZigCard",
		bar: "Barre",
		client: "Client",
		product: "Produit",
		productCategory: "Catégorie du produit",
		quantity: "Quantité",
		source: "Source",
		paymentMethod: "Mode de paiement",
		status: {
			canceled: "Annulé",
			approved: "Approuvé",
			label: "Statut",
		},
		paidInOtherEvent: "Payé dans un autre événement",
		document: "Document",
		acquirer: "Acquéreur",
		acquirerTransactionId: "Acquisition de l'ID de transaction",
		cardBrand: "Drapeau de carte",
		nsu: "NSU",
		nsuHost: "NSU Host",
		authorizationCode: "Code d'autorisation",
		bin: "Bin",
		service: "Service",
		value: "Valeur",
		hawkerDocument: "Document ambulant",
		hawkerName: "Nom ambulant",
	},
	transactionTypes: {
		recharge: "Recharge",
		transaction: "Transaction",
		ficha: "Jeton",
		canceled: "Annulée",
		refund: "Remboursement",
		digitalCashless: "Cashless digital",
	},
	maxSearchPeriod: "La période de recherche maximale est de 31 jours",
	invalidPeriod: {
		beforeOpening:
			"La date de début ne peut pas être antérieure à l'ouverture de l'événement",
		afterClosing:
			"La date de fin ne peut pas être postérieure à la fermeture de l'événement",
		afterCurrent: "La date de fin ne peut pas être postérieure à la date actuelle",
	},
	exportExcel: {
		success: "Email avec export envoyé avec succès.",
		title: "Rapport d'exportation",
		label: "Veuillez saisir votre email pour envoyer la feuille de calcul",
		error: "Veuillez saisir un email valide",
		placeholder: "Entrez votre email",
	},
};
